import { render, staticRenderFns } from "./CampaignsHeadline.vue?vue&type=template&id=4553296f&scoped=true"
import script from "./CampaignsHeadline.vue?vue&type=script&lang=ts"
export * from "./CampaignsHeadline.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsHeadline.vue?vue&type=style&index=0&id=4553296f&prod&lang=scss&scoped=true"
import style1 from "./CampaignsHeadline.vue?vue&type=style&index=1&id=4553296f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4553296f",
  null
  
)

export default component.exports